import { TextField as TextFieldElement } from '@treneo/shared/forms';
import { useAppTranslations } from '@treneo/shared/i18n';
import { AlertWarning, Box, BUTTON_VARIANTS, LoadingButton } from '@treneo/shared/ui';

import { courseFormFieldNames } from '../course-form-field-names';

type Props = Readonly<{
  trainerEmail: string | null | undefined;
  isInvitePending: boolean;
  hasPendingForEmail: boolean;
  onInvite: () => void;
}>;

export const InviteTrainerByEmail = ({
  trainerEmail,
  isInvitePending,
  hasPendingForEmail,
  onInvite
}: Props) => {
  const { t } = useAppTranslations();

  return (
    <>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
        <TextFieldElement
          name={courseFormFieldNames.trainerEmail}
          label={t('trainers.inviteTrainerByEmail')}
          type='email'
          fullWidth
          disabled={isInvitePending}
          slotProps={{ inputLabel: { shrink: true } }}
        />
        <LoadingButton
          variant={BUTTON_VARIANTS.contained}
          onClick={onInvite}
          disabled={!trainerEmail || isInvitePending || hasPendingForEmail}
          isLoading={isInvitePending}
          loadingText={t('trainers.sending')}
        >
          {t('trainers.invite')}
        </LoadingButton>
      </Box>
      {hasPendingForEmail && (
        <Box sx={{ mt: 1 }}>
          <AlertWarning text={t('trainers.invitationAlreadyPending')} />
        </Box>
      )}
    </>
  );
};
